import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M2.5 18.333h15M4.667 6.983H3.333a.836.836 0 0 0-.833.834V15c0 .458.375.833.833.833h1.334A.836.836 0 0 0 5.5 15V7.817a.836.836 0 0 0-.833-.834M10.667 4.325H9.333a.836.836 0 0 0-.833.834V15c0 .459.375.834.833.834h1.334A.836.836 0 0 0 11.5 15V5.16a.836.836 0 0 0-.833-.834M16.667 1.667h-1.334a.836.836 0 0 0-.833.833V15c0 .459.375.834.833.834h1.334A.836.836 0 0 0 17.5 15V2.5a.836.836 0 0 0-.833-.833"
    }, null, -1)
  ]))]))
}
export default { render: render }